module.exports = __webpack_public_path__ + "static/media/horse.b47dd793.svg";